export default "__VITE_ASSET__8f074846__"